module.exports = __webpack_public_path__ + "sz.svg?9ec8da3eae5c07ea00da519d29071389";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/sz.svg
// module id = 1380
// module chunks = 0